import { FC, useState } from 'react';
import { SetPasswordProps } from './setPassword.type';
import { ErrorMessages, LoginPlaceholder } from '../../utils/helper.type';
import { useTranslation } from 'react-i18next';
import { useResponsiveLayout } from '../../hooks/useResponsiveLayout';
import { Navigate, useNavigate } from 'react-router-dom';
import { renderDesktopView, renderTabletView } from './setPasswordHelper';
import { route } from '../../service/router';
import { useResetPasswordData } from '../../hooks/useAuthData';
import { getPasswordParams } from '../../utils/helper';

const SetPassword: FC<SetPasswordProps> = () => {
  const { isDesktop } = useResponsiveLayout();
  const [password, setPassword] = useState<string>('');
  const [confirmPassword, setConfirmPassword] = useState<string>('');
  const [showPassword, setShowPassword] = useState<boolean>(false);
  const [showConfirmPassword, setShowConfirmPassword] =
    useState<boolean>(false);
  const { i18n } = useTranslation();
  const loginTranslation: LoginPlaceholder =
    i18n.getResourceBundle(i18n.language, 'translation')?.login.placeholder ||
    {};
  const navigate = useNavigate();

  const { resetPassword, isResetLoading, error, setError } =
    useResetPasswordData();

  const [params] = useState(() => getPasswordParams());
  const { code, email } = params;

  if (!code || !email)
    return (
      <Navigate
        to={route.invalidLinkPage}
        replace
        data-testid="navigate-invalid"
      />
    );

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();

    if (isResetLoading) {
      console.log(
        '[ResetLoading] Already in progress... skipping this request',
      );
      return;
    }

    setError(null);
    if (password !== confirmPassword) {
      setError(ErrorMessages.PASSWORD_MISMATCH);
      return;
    }

    try {
      if (!email || code === null) return;
      await resetPassword(email, password, code);
    } catch (err) {
      setError(ErrorMessages.PASSWORD_FAILED);
    }
  };

  const handleBackToLogin = (): void => {
    navigate(route.login);
  };

  return (
    <div
      className="relative min-h-screen w-full"
      data-testid="set-password-container"
    >
      {isDesktop
        ? renderDesktopView(
            handleSubmit,
            password,
            setPassword,
            confirmPassword,
            setConfirmPassword,
            loginTranslation,
            showPassword,
            setShowPassword,
            showConfirmPassword,
            setShowConfirmPassword,
            error,
            'setPassword.enterNew',
            'setPassword.resetPassword',
            isResetLoading,
            !password || !confirmPassword,
          )
        : renderTabletView(
            handleSubmit,
            password,
            setPassword,
            confirmPassword,
            setConfirmPassword,
            loginTranslation,
            showPassword,
            setShowPassword,
            showConfirmPassword,
            setShowConfirmPassword,
            error,
            handleBackToLogin,
            'setPassword.enterNewPassword',
            'setPassword.resetPassword',
            isResetLoading,
            !password || !confirmPassword,
          )}
    </div>
  );
};

export default SetPassword;
